// Due to a bug in the ChromeDriver, Angular 2 keyboard events are not triggered by `sendKeys`
// during E2E tests when using dot notation such as `(keydown.rightArrow)`. To get around this,
// we are temporarily using a single (keydown) handler.
// See: https://github.com/angular/angular/issues/9419

export enum KeyCode {
  UpArrow = 38,
  DownArrow = 40,
  RightArrow = 39,
  LeftArrow = 37,

  PageUp = 33,
  PageDown = 34,

  Home = 36,
  End = 35,
  Enter = 13,
  Space = 32,
  Tab = 9,
  Escape = 27,
  Backspace = 8,
  Delete = 46,

  A = 65,
  K = 75,
  S = 83,
  Z = 90,

  Zero = 48,
  Nine = 91,
  Comma = 188,
}

export enum ModifierKey {
  Shift = 'SHIFT',
  Ctrl = 'CTRL',
  Alt = 'ALT',
  Command = 'CMD',
}

export enum KeySymbol {
  Command = '⌘',
}
